import React, { useEffect, useRef } from 'react';

const CursorTrail = () => {
    const cursorTrailRef = useRef(null);

    useEffect(() => {
        let posX = 0, posY = 0;
        let mouseX = 0, mouseY = 0;
        let isActive = false;
        let animationFrameId;

        const cursorTrail = cursorTrailRef.current;

        // Check for reduced motion preference or touch device
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        if (prefersReducedMotion || isTouchDevice) return;

        const mouseMoveHandler = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
            if (!isActive) {
                isActive = true;
                animateCursor();
            }
        };

        const animateCursor = () => {
            if (!cursorTrail) return;

            posX += (mouseX - posX) * 0.35;
            posY += (mouseY - posY) * 0.35;

            cursorTrail.style.transform = `translate3d(${posX - 15}px, ${posY - 15}px, 0)`;
            cursorTrail.style.opacity = '0.3'; // Increased visibility slightly

            // Stop animation if cursor stops moving ensuring performance
            if (Math.abs(mouseX - posX) < 0.1 && Math.abs(mouseY - posY) < 0.1) {
                isActive = false;
            } else {
                animationFrameId = requestAnimationFrame(animateCursor);
            }
        };

        document.addEventListener('mousemove', mouseMoveHandler, { passive: true });

        return () => {
            document.removeEventListener('mousemove', mouseMoveHandler);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return <div className="cursor-trail" ref={cursorTrailRef} aria-hidden="true"></div>;
};

export default CursorTrail;
